export { default } from "./ShareOption";
